module.exports = __webpack_public_path__ + "static/media/to-label.204aa9ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/to-label.svg
// module id = 779
// module chunks = 0